module.exports = __webpack_public_path__ + "img/investimenti.7fef1430.svg";